import React, { useState, useContext, useEffect } from 'react'
import {
    Stack,
    FormControl,
    useColorModeValue,
    GridItem,
    FormLabel,
    Flex,
    Heading,
    Text,
    Button,
    useToast,
    Spinner,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Alert,
    AlertIcon,
} from "@chakra-ui/react";
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import UserContext from "../State/UserContext";

export default function Facturacion() {
    const [archivoDetalleFileList, setArchivoDetalleFileList] = useState([]);
    const [facturaFileList, setFacturaFileList] = useState([]);
    const [historiasClinicasfileList, setHistoriasClinicasFileList] = useState([]);
    const [uploading, setuploading] = useState(false);
    const [uploadStatusAlert, setUploadStatusAlert] = useState();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { user } = useContext(UserContext);
    const toast = useToast()

    useEffect(() => {
        onOpen();
    }, [])

    async function handleUpload() {
        setuploading(true);
        var error = false;
        if (archivoDetalleFileList.length > 0) {
            if (facturaFileList.length > 0) {
                archivoDetalleFileList.forEach(detailFile => {
                    var hasCorrespondingFile = false;
                    facturaFileList.forEach(factura => {
                        if (detailFile.name.substring(1, 15) === factura.name.substring(0, factura.name.indexOf('.'))) {
                            hasCorrespondingFile = true;
                        }
                    });
                    if (!hasCorrespondingFile) {
                        setUploadStatusAlert(
                            <Alert status="warning" borderRadius="5px">
                                <AlertIcon />
                                Hay archivos que no tienen su contraparte correspondiente (falta factura para archivo de detalle o viceversa)!&nbsp;
                            </Alert>
                        );
                        setuploading(false);
                        error = true;
                    }
                });
            } else {
                setUploadStatusAlert(
                    <Alert status="warning" borderRadius="5px">
                        <AlertIcon />
                        No se subio ninguna factura!&nbsp;
                    </Alert>
                );
                setuploading(false);
                error = true;
            }
        } else {
            setUploadStatusAlert(
                <Alert status="warning" borderRadius="5px">
                    <AlertIcon />
                        No se subio ningun archivo de detalle!&nbsp;
                    </Alert>
            );
            setuploading(false);
            error = true;
        }

        if (error) {
            return;
        }

        var allFilesList = [];
        archivoDetalleFileList.forEach(detailFile => {
            var fileCopy = new File([detailFile], detailFile.name, { type: detailFile.type });
            Object.defineProperty(fileCopy, 'name', {
                writable: true,
                value: user.user?.providerCuit.trim() + "/Pendientes/" + fileCopy.name
            });
            allFilesList.push(fileCopy);
        });
        facturaFileList.forEach(factura => {
            var fileCopy = new File([factura], factura.name, { type: factura.type });
            Object.defineProperty(fileCopy, 'name', {
                writable: true,
                value: user.user?.providerCuit.trim() + "/Pendientes/" + fileCopy.name
            });
            allFilesList.push(fileCopy);
        });
        historiasClinicasfileList.forEach(historia => {
            var fileCopy = new File([historia], historia.name, { type: historia.type });
            Object.defineProperty(fileCopy, 'name', {
                writable: true,
                value: user.user?.providerCuit.trim() + "/HC/" + fileCopy.name
            });
            allFilesList.push(fileCopy);
        });

        var formData = new FormData();
        allFilesList.forEach(element => {
            formData.append(element.name, element);
        });

        var response = await fetch("provider/uploadFacturacion", {
            method: "POST",
            headers: { "userToken": user.token },
            body: formData
        });
        if (!response.ok) {
            var msg = response.status === 413 ? "Los archivos no pueden superar los 40 mb" : "Ocurrio un error al subir los archivos"
            setUploadStatusAlert(
                <Alert status="warning" borderRadius="5px">
                    <AlertIcon />
                    { msg }
                    </Alert>
            );
            setuploading(false);
            return;
        }

        setArchivoDetalleFileList([]);
        setFacturaFileList([]);
        setHistoriasClinicasFileList([]);

        setuploading(false);
        toast({
            title: "Exito!.",
            description: "Los archivos fueron subidos correctamente.",
            status: "success",
            duration: 5000,
            isClosable: true,
        })
    }

    const propsArchivoDetalle = {
        onRemove: file => {
            const index = archivoDetalleFileList.indexOf(file);
            const newFileList = archivoDetalleFileList.slice();
            newFileList.splice(index, 1);
            setArchivoDetalleFileList(newFileList);
        },
        beforeUpload: file => {
            if (!file.type.includes("text") && !file.type.includes("sheet")) {
                setUploadStatusAlert(
                    <Alert status="error" borderRadius="5px">
                        <AlertIcon />
                        El formato del archivo es incorrecto!&nbsp;
                    </Alert>
                );
                return Upload.LIST_IGNORE;
            }
            if (!/[AI][0-9]{5}[AC][0-9]{8}_[0-9]{2}/.test(file.name)) {
                setUploadStatusAlert(
                    <Alert status="error" borderRadius="5px">
                        <AlertIcon />
                        El nombre del archivo es incorrecto!&nbsp;
                    </Alert>
                );
                return Upload.LIST_IGNORE;
            }
            setArchivoDetalleFileList([file]);
            setUploadStatusAlert("");
            return false;
        },
        archivoDetalleFileList,
    };

    const propsFactura = {
        onRemove: file => {
            const index = facturaFileList.indexOf(file);
            const newFileList = facturaFileList.slice();
            newFileList.splice(index, 1);
            setFacturaFileList(newFileList);
        },
        beforeUpload: file => {
            if (!file.type.includes("pdf")) {
                setUploadStatusAlert(
                    <Alert status="error" borderRadius="5px">
                        <AlertIcon />
                        El formato del archivo es incorrecto!&nbsp;
                    </Alert>
                );
                return Upload.LIST_IGNORE;
            }
            if (!/[0-9]{5}[AC][0-9]{8}/.test(file.name)) {
                setUploadStatusAlert(
                    <Alert status="error" borderRadius="5px">
                        <AlertIcon />
                        El nombre del archivo es incorrecto!&nbsp;
                    </Alert>
                );
                return Upload.LIST_IGNORE;
            }
            setFacturaFileList([file]);
            setUploadStatusAlert("");
            return false;
        },
        facturaFileList,
    };

    const propsHisoriasClinicas = {
        onRemove: file => {
            const index = historiasClinicasfileList.indexOf(file);
            const newFileList = historiasClinicasfileList.slice();
            newFileList.splice(index, 1);
            setHistoriasClinicasFileList(newFileList);
        },
        beforeUpload: file => {
            if (!file.type === "" && !file.type.includes("pdf") && !file.type.includes("zip")) {
                setUploadStatusAlert(
                    <Alert status="warning" borderRadius="5px">
                        <AlertIcon />
                        El formato del archivo es incorrecto!&nbsp;
                    </Alert>
                );
                return Upload.LIST_IGNORE;
            }
            setHistoriasClinicasFileList([...historiasClinicasfileList, file]);
            setUploadStatusAlert("");
            return false;
        },
        historiasClinicasfileList,
    };

    return (
        <Flex
            height="100vh"
            alignItems="center"
            justifyContent="center"
            backgroundColor="gray.100"
        >
            <Stack
                boxShadow="md"
                bg={useColorModeValue('white', 'gray.600')}
                rounded={'xl'}
                p={10}
                spacing={8}
                align={'center'}>
                <Button marginLeft="auto" onClick={() => { onOpen() }}>
                    Info
                </Button>
                <Stack align={'center'} spacing={2}>
                    <Heading
                        textTransform={'uppercase'}
                        fontSize={'3xl'}
                        color={useColorModeValue('gray.600', 'gray.200')}>
                        Carga de Facturación
                    </Heading>
                    <Text textAlign="center" fontSize={'lg'} color={'gray.600'}>
                        Complete todos los campos para presentar la documentacion de facturación de su entidad.
                    </Text>
                </Stack>
                <FormControl as={GridItem} colSpan={[6, 3]}>
                    <FormLabel
                        for="tipoDoc"
                        fontSize="sm"
                        fontWeight="md"
                        color={useColorModeValue("gray.700", "gray.50")}
                    >
                        Archivo de detalle
                    </FormLabel>
                    <Upload fileList={archivoDetalleFileList} accept=".txt, .xlsx, .xls" {...propsArchivoDetalle} maxCount={1}>
                        <Button icon={<UploadOutlined />}>Seleccione archivo</Button>
                    </Upload>
                </FormControl>

                <FormControl as={GridItem} colSpan={6}>
                    <FormLabel
                        for="numDoc"
                        fontSize="sm"
                        fontWeight="md"
                        color={useColorModeValue("gray.700", "gray.50")}
                    >
                        Factura
                    </FormLabel>
                    <Upload fileList={facturaFileList} accept=".pdf" {...propsFactura} maxCount={1}>
                        <Button icon={<UploadOutlined />}>Seleccione archivo</Button>
                    </Upload>
                </FormControl>

                <FormControl as={GridItem} colSpan={6}>
                    <FormLabel
                        for="numDoc"
                        fontSize="sm"
                        fontWeight="md"
                        color={useColorModeValue("gray.700", "gray.50")}
                    >
                        Historias Clinicas
                    </FormLabel>
                    <Upload fileList={historiasClinicasfileList} accept=".rar, .pdf, .zip" {...propsHisoriasClinicas}>
                        <Button icon={<UploadOutlined />}>Seleccione archivos</Button>
                    </Upload>
                </FormControl>

                <FormControl as={GridItem} colSpan={6}>
                    <Button
                        borderRadius="8px"
                        variant="solid"
                        type="primary" color="#004990"
                        width="full"
                        onClick={handleUpload}
                        loading={uploading}
                        style={{ marginTop: 16 }}
                        disabled={uploading}
                    >
                        {uploading ? <Spinner color="#004990" /> : 'Subir'}
                    </Button>
                </FormControl>
                <Modal size={"xl"} isOpen={isOpen} onClose={onClose}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Instructivo Carga de Archivos (Facturación)</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <p>Se deberá realizar la carga de la documentación de la facturación ambulatoria y luego la facturación internados por separado (cargas individuales).</p>
                            <br></br>
                            <p><b>Archivo de Detalle</b>: El tipo de documento cargado debe ser TXT y el archivo cargado deberá tener el siguiente nombre o nomenclatura; la primera letra identifica si es un archivo de Ambulatorio (A) o un archivo de Internación (I); la segunda letra identifica el tipo de factura (Puede ser A o C); los números son los identificatorios de la factura; y el archivo siempre debe terminar en “_01”.</p>
                            <p>Ejemplos:</p>
                            <ul style={{ marginLeft: 50 }}>
                                <li><b>AxxxxxAxxxxxxxx_01</b> donde la primera <b>A</b> significa que es un archivo de detalle para Ambulatorio; la segunda letra representa el tipo de Factura que se va a cargar (Puede ser A o C); las equis representan la numeración de la factura; y el archivo siempre debe terminar en “_01”. <b>Ejemplo</b>: A12345A12345678_01</li>
                                <li><b>IxxxxxAxxxxxxxx_01</b> donde la primera <b>I</b> significa que es un archivo de detalle para Internación; la segunda letra representa el tipo de Factura que se va a cargar (Puede ser A o C); las equis representan la numeración de la factura; y el archivo siempre debe terminar en “_01”. <b>Ejemplo</b>: I12345A12345678_01</li>
                            </ul>
                            <p><b>Factura</b>: El tipo de documento cargado debe ser PDF y el archivo cargado deberá tener un nombre o nomenclatura parecido al que se utiliza para el archivo de detalle; se escribe una letra que identifica el tipo de factura y los otros caracteres identifican a la factura. Adicionalmente, la nomenclatura de la factura debe coincidir con la del archivo TXT cargado.</p>
                            <ul style={{ marginLeft: 50 }}>
                                <li><b>xxxxxAxxxxxxxx</b> donde la letra cargada representa el tipo de Factura que se va a cargar (Puede ser A o C); las equis representan la numeración de la factura. <b>Ejemplo</b>: 12345A12345678</li>
                                <li><b>xxxxxCxxxxxxxx</b> donde la letra cargada representa el tipo de Factura que se va a cargar (Puede ser A o C); las equis representan la numeración de la factura. <b>Ejemplo</b>: 12345C12345678</li>
                                <li>La nomenclatura del archivo de detalle y la factura deben coincidir. Si el usuario carga un Archivo de detalle nombrado <b>A</b>44444<b>A</b>55558888_01, la factura adjuntada debe tener como nombre 44444<b>A</b>55558888.</li>
                                <li>En caso de que los nombres no coincidan, el portal impedirá subir la documentación.</li>
                            </ul>
                            <p><b>Historias Clínicas</b>: Es un campo que permite al usuario cargar un archivo PDF o un conjunto de archivos comprimidos en formato .RAR o .ZIP.</p>
                            <br></br>
                            <p><b>Nota</b>: El conjunto de archivos enviados (Archivo Detalle, Factura, Historias clínicas) no debe ser mayor a 40mb.</p>
                            <br></br>
                            <p>Ante cualquier duda o complicación en la carga de documentos enviar correo electrónico a la casilla liquidacionesdelplandesalud@hbritanico.com.ar</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button colorScheme="blue" mr={3} onClick={onClose}>
                                Cerrar
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
                {uploadStatusAlert}
            </Stack>
        </Flex >
    )
}